import { Check } from "lucide-react";
import { Fragment } from "react";
import { cn } from "@/lib/utils";
import { SETUP_STEPS, SETUP_STEP_LABEL, type SetupStep } from "./campaignDraft";

interface SetupStepBarProps {
  step: SetupStep;
  /** Steps after this one stay disabled until the earlier ones are valid. */
  furthest: SetupStep;
  onSelect: (step: SetupStep) => void;
  /** Editing shows only Placements and Images, numbered from 1. */
  steps?: SetupStep[];
}

export function SetupStepBar({
  step,
  furthest,
  onSelect,
  steps = SETUP_STEPS,
}: SetupStepBarProps) {
  return (
    <ol className="mt-3.5 flex flex-wrap items-center justify-center gap-2.5">
      {steps.map((s, i) => {
        const current = s === step;
        const done = s < step;
        const disabled = s > furthest;
        return (
          <Fragment key={s}>
            {i > 0 && <li aria-hidden="true" className="h-px w-7 bg-border" />}
            <li>
              <button
                type="button"
                disabled={disabled}
                aria-current={current ? "step" : undefined}
                aria-label={`Step ${i + 1}: ${SETUP_STEP_LABEL[s]}`}
                onClick={() => onSelect(s)}
                className={cn(
                  "flex min-h-9 items-center gap-2 text-sm font-semibold transition-colors disabled:cursor-not-allowed disabled:opacity-50",
                  current || done ? "text-ink" : "text-text-muted",
                )}
              >
                <span
                  className={cn(
                    "flex size-6 items-center justify-center rounded-full border-[1.5px] text-xs",
                    current &&
                      "border-primary bg-primary text-primary-foreground",
                    done && "border-primary text-primary",
                    !current && !done && "border-border",
                  )}
                >
                  {done ? (
                    <Check className="size-3.5" aria-hidden="true" />
                  ) : (
                    i + 1
                  )}
                </span>
                {SETUP_STEP_LABEL[s]}
              </button>
            </li>
          </Fragment>
        );
      })}
    </ol>
  );
}
